module.exports = __webpack_public_path__ + "img/bell-selected-white.cf6150fe.png";